import { useAxios } from "../../hooks/useAxios";
import {
  Mission,
  SaveMissionParams
} from "./missions";

interface MissionPathParams {
  id: string;
}

type MissionsEndpointConfig = {
  GET_MISSIONS: EndpointConfig<
    Record<string, never>,
    { results: Mission[] }
  >;
  GET_MISSION: EndpointConfig<
    MissionPathParams,
    Mission
  >;
  CREATE_MISSION: EndpointConfig<
    SaveMissionParams,
    Mission
  >;
  UPDATE_MISSION: EndpointConfig<
    MissionPathParams & SaveMissionParams,
    Mission
  >;
  DELETE_MISSION: EndpointConfig<
    MissionPathParams,
    { message: string }
  >;
  GET_LATENCY: EndpointConfig<
    { date: string },
    { date: string; latencySeconds: number; editable: boolean; missionDay: number }
  >;
};

const requestInitialisers: RequestConfig<MissionsEndpointConfig> = {
  GET_MISSIONS: (
    () => ({
      url: "/mission",
      method: "GET"
    })
  ),
  GET_MISSION: (
    ({ id }) => ({
      url: `/mission/${id}`,
      method: "GET"
    })
  ),
  CREATE_MISSION: (
    params => ({
      url: "/mission",
      method: "POST",
      data: params
    })
  ),
  UPDATE_MISSION: (
    ({ id, ...params }) => ({
      url: `/mission/${id}`,
      method: "PUT",
      data: params
    })
  ),
  DELETE_MISSION: (
    ({ id }) => ({
      url: `/mission/${id}`,
      method: "DELETE"
    })
  ),
  GET_LATENCY: (
    ({ date }) => ({
      url: "/mission/latency",
      method: "GET",
      params: { date }
    })
  )
};

export const useMissionsApi: UseApiRequest<MissionsEndpointConfig> = name => useAxios(requestInitialisers[ name ]);
